import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Checkbox } from 'antd';

import style from './styles.scss';
import { getCategoryLabel } from '../../../common/utils';

const SelectedSetComp = ({
  liveSets,
  allSelected,
  currentTypologySet,
  setTypologySets
}) => {
  const categories = useMemo(() => {
    return liveSets?.data?.categories?.map((data, i) => {
      return <div className={style.tableText}>{getCategoryLabel(data)}</div>;
    });
  }, [liveSets]);

  const getIndicatorText = () => {
    if (allSelected) {
      return `All sets selected`;
    } else {
      return `selection in progress`;
    }
  };

  const handleAllSelection = (event) => {
    setTypologySets((prev) =>
      prev.map((p) => {
        if (p.typologyId === currentTypologySet.typologyId) {
          return {
            ...p,
            segmentCombinationIds: event.target.checked
              ? liveSets?.data?.combinations?.map((m) => m.id)
              : []
          };
        } else {
          return p;
        }
      })
    );
  };

  const handleSelection = (event, combinationId) => {
    setTypologySets((prev) =>
      prev.map((p) => {
        p.segmentCombinationIds = p.segmentCombinationIds.filter(
          (f) => liveSets?.data?.combinations.findIndex((c) => c.id === f) > -1
        );
        if (p.typologyId === currentTypologySet.typologyId) {
          return {
            ...p,
            segmentCombinationIds: event.target.checked
              ? [...p.segmentCombinationIds, combinationId]
              : p.segmentCombinationIds.filter((f) => f !== combinationId)
          };
        } else {
          return p;
        }
      })
    );
  };

  return (
    <div className={style.flexTable}>
      <div className={style.seletedSetsView}>
        {liveSets?.data?.combinations ? (
          <>
            <div
              className={classNames(
                allSelected ? style.selectedHeaderAll : style.selectedHeader
              )}>
              <p className={style.headerCheck}>
                <Checkbox checked={allSelected} onChange={handleAllSelection} />
              </p>
              {categories}
            </div>
            {liveSets?.data?.combinations?.map((combination) => {
              return (
                <div className={style.DynamicSelects} key={combination.id}>
                  <p
                    className={style.headerCheck}
                    style={{ paddingLeft: '19px' }}>
                    <Checkbox
                      checked={
                        currentTypologySet.segmentCombinationIds.indexOf(
                          combination.id
                        ) > -1
                      }
                      onChange={(e) => handleSelection(e, combination.id)}
                    />
                  </p>
                  {combination.entries.map((values, i) => {
                    return (
                      <div key={`t-${i}`} className={style.tableText}>
                        {values.value}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </>
        ) : (
          <div className={style.noSetsAvailable}>
            No Segment Set Available, typology would be applicable to the entire
            universe of customers
          </div>
        )}
      </div>
      {/* <p className={style.selectedIndicator}>{getIndicatorText()}</p> */}
    </div>
  );
};

export default SelectedSetComp;
